import { render, staticRenderFns } from "./PatientDoctorConclusion.vue?vue&type=template&id=57910bea&"
import script from "./PatientDoctorConclusion.vue?vue&type=script&lang=js&"
export * from "./PatientDoctorConclusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports